import { Action } from '@ngrx/store';
import { Reference } from 'src/app/core/utils/action-helper.util';
import { AddCSSThemePayload, AddCSSThemeResponse, CopyCSSThemePayload, CopyCSSThemeResponse } from '../../_models/page.model';
import { Error } from '../../_models/auth.models';
import { Pages, Theme } from '../../_models/settings.models';

/**
 * Pages action types
 */
export enum ThemesActionTypes {
  LOAD_THEMES = '[Themes] Load Themes',
  LOAD_THEMES_SUCCESS = '[Themes] Load Themes Success',
  LOAD_THEMES_FAILED = '[Themes] Load Themes Failed',
  LOAD_THEME = '[Themes] Load Theme',
  LOAD_THEME_SUCCESS = '[Themes] Load Theme Success',
  LOAD_THEME_FAILED = '[Themes] Load Theme Failed',
  ADD_THEME = '[Themes] Add Theme',
  ADD_THEME_SUCCESS = '[Themes] Add Theme Success',
  ADD_THEME_FAILED = '[Themes] Add Theme Failed',
  DELETE_THEME = '[Themes] Delete Theme',
  DELETE_THEME_SUCCESS = '[Themes] Delete Theme Success',
  DELETE_THEME_FAILED = '[Themes] Delete Theme Failed',
  UPDATE_THEME = '[Themes] Update Theme',
  UPDATE_THEME_SUCCESS = '[Themes] Update Theme Success',
  UPDATE_THEME_FAILED = '[Themes] Update Theme Failed',
  COPY_THEME = '[Themes] Copy Theme',
  COPY_THEME_SUCCESS = '[Themes] Copy Theme Success',
  COPY_THEME_FAILED = '[Themes] Copy Theme Failed',
  RESET = '[Themes] RESET',
  LOAD_DEFAULT_THEME_FOR_APPLICATION = '[Themes] Load Default Theme for Application',
  LOAD_DEFAULT_THEME_FOR_APPLICATION_SUCCESS = '[Themes] Load Default Theme for Application Success',
  LOAD_DEFAULT_THEME_FOR_APPLICATION_FAILED = '[Themes] Load Default Theme for Application Failed',
}

/**
 * Operations
 */

 export class CopyCSSTheme extends Reference implements Action {
  readonly type = ThemesActionTypes.COPY_THEME;

  constructor(public appId: string, public payload: CopyCSSThemePayload) {
    super();
  }
}

export class CopyCSSThemeSuccess extends Reference implements Action {
  readonly type = ThemesActionTypes.COPY_THEME_SUCCESS;

  constructor(public payload: CopyCSSThemeResponse) {
    super();
  }
}

export class CopyCSSThemeFailed extends Reference implements Action {
  readonly type = ThemesActionTypes.COPY_THEME_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadCSSThemes implements Action {
  readonly type = ThemesActionTypes.LOAD_THEMES;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public applicationId: string, public force: boolean = false) {}
}

export class LoadCSSThemesSuccess implements Action {
  readonly type = ThemesActionTypes.LOAD_THEMES_SUCCESS;

  constructor(public applicationId: string, public payload: Array<any>) {}
}

export class LoadCSSThemesFailed implements Action {
  readonly type = ThemesActionTypes.LOAD_THEMES_FAILED;

  constructor(public payload: Error, public applicationId: string) {}
}

export class LoadCSSTheme implements Action {
  readonly type = ThemesActionTypes.LOAD_THEME;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public appId: string, public themeId: string) {}
}

export class LoadCSSThemeSuccess implements Action {
  readonly type = ThemesActionTypes.LOAD_THEME_SUCCESS;

  constructor(
    public appId: string,
    public themeId: string,
    public payload: any
  ) {}
}

export class LoadCSSThemeFailed implements Action {
  readonly type = ThemesActionTypes.LOAD_THEME_FAILED;

  constructor(public payload: Error) {}
}

export class AddCSSTheme extends Reference implements Action {
  readonly type = ThemesActionTypes.ADD_THEME;

  constructor(public payload: AddCSSThemePayload) {
    super();
  }
}

export class AddCSSThemeSuccess extends Reference implements Action {
  readonly type = ThemesActionTypes.ADD_THEME_SUCCESS;

  constructor(public payload: AddCSSThemeResponse) {
    super();
  }
}

export class AddCSSThemeFailed extends Reference implements Action {
  readonly type = ThemesActionTypes.ADD_THEME_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class DeleteCSSTheme extends Reference implements Action {
  readonly type = ThemesActionTypes.DELETE_THEME;

  constructor(public themeId: string, public appId: string) {
    super();
  }
}

export class DeleteCSSThemeSuccess extends Reference implements Action {
  readonly type = ThemesActionTypes.DELETE_THEME_SUCCESS;

  constructor(public themeId: string, public appId: string) {
    super();
  }
}

export class DeleteCSSThemeFailed extends Reference implements Action {
  readonly type = ThemesActionTypes.DELETE_THEME_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateCSSTheme extends Reference implements Action {
  readonly type = ThemesActionTypes.UPDATE_THEME;

  constructor(public payload: AddCSSThemePayload) {
    super();
  }
}

export class UpdateCSSThemeSuccess extends Reference implements Action {
  readonly type = ThemesActionTypes.UPDATE_THEME_SUCCESS;

  constructor(public payload: Theme) {
    super();
  }
}

export class UpdateCSSThemeFailed extends Reference implements Action {
  readonly type = ThemesActionTypes.UPDATE_THEME_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class Reset implements Action {
  readonly type = ThemesActionTypes.RESET;

  constructor() {}
}

export class LoadDefaultCSSThemeForApplication implements Action {
  readonly type = ThemesActionTypes.LOAD_DEFAULT_THEME_FOR_APPLICATION;
  appId: any;

  /**
   * @param force to forcefully fetch, regardless of caching enabled
   */
  constructor(public TableId: string, public force: boolean = false) {}
}

export class LoadDefaultCSSThemeForApplicationSuccess implements Action {
  readonly type = ThemesActionTypes.LOAD_DEFAULT_THEME_FOR_APPLICATION_SUCCESS;

  constructor(public tableId: string, public payload: Array<any>) {}
}

export class LoadDefaultCSSThemeForApplicationFailed implements Action {
  readonly type = ThemesActionTypes.LOAD_DEFAULT_THEME_FOR_APPLICATION_FAILED;

  constructor(public payload: Error) {}
}

/**
 * Available types
 */
export type Actions =
  | LoadCSSThemes
  | LoadCSSThemesSuccess
  | LoadCSSThemesFailed
  | LoadCSSTheme
  | LoadCSSThemeSuccess
  | LoadCSSThemeFailed
  | AddCSSTheme
  | AddCSSThemeSuccess
  | AddCSSThemeFailed
  | DeleteCSSTheme
  | DeleteCSSThemeSuccess
  | DeleteCSSThemeFailed
  | UpdateCSSTheme
  | UpdateCSSThemeSuccess
  | UpdateCSSThemeFailed
  | Reset
  | CopyCSSTheme
  | CopyCSSThemeSuccess
  | CopyCSSThemeFailed
  | LoadDefaultCSSThemeForApplication
  | LoadDefaultCSSThemeForApplicationSuccess
  | LoadDefaultCSSThemeForApplicationFailed;
